module.exports = __webpack_public_path__ + "static/img/huishengwenhua_bg.6b545b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huishengwenhua_bg.png
// module id = 9j44
// module chunks = 1